function animateCounter(el) {
  const target = parseInt(el.getAttribute("data-target"), 10);
  const suffix = el.getAttribute("data-suffix") || "";
  if (isNaN(target)) return;

  const duration = 3000;
  const start = performance.now();

  function step(now) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(eased * target) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

function initializeMetricsAnimations() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 },
  );

  document
    .querySelectorAll(".rbsv4-info-metrics__info-card-metric[data-target]")
    .forEach((el) => observer.observe(el));
}

document.addEventListener("DOMContentLoaded", initializeMetricsAnimations);

function initTimelineModal() {
  const modal = document.querySelector(".rbsv4-timeline-modal");
  const openers = document.querySelectorAll("[data-timeline-open]");
  if (!modal || !openers.length) return;

  const closers = modal.querySelectorAll("[data-timeline-close]");
  let closeTimer = null;

  function open() {
    clearTimeout(closeTimer);
    modal.hidden = false;
    // Double rAF so the [hidden] -> visible transition actually animates.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => modal.classList.add("is-visible"));
    });
    document.documentElement.classList.add("overflow-hidden");
  }

  function close() {
    modal.classList.remove("is-visible");
    document.documentElement.classList.remove("overflow-hidden");
    closeTimer = setTimeout(() => {
      modal.hidden = true;
    }, 300);
  }

  openers.forEach((btn) => btn.addEventListener("click", open));
  closers.forEach((btn) => btn.addEventListener("click", close));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) close();
  });
}

document.addEventListener("DOMContentLoaded", initTimelineModal);

function initTimelineDots() {
  const trackWrap = document.querySelector(".rbsv4-timeline-modal__track-wrap");
  const items = document.querySelectorAll(".rbsv4-timeline-modal__item");
  const dots = document.querySelectorAll(".rbsv4-timeline-modal__dot");
  if (!trackWrap || !items.length || !dots.length) return;

  function setActive(index) {
    dots.forEach((dot) => {
      dot.classList.toggle("is-active", dot.getAttribute("data-index") === String(index));
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActive(entry.target.getAttribute("data-index"));
        }
      });
    },
    { root: trackWrap, threshold: 0.6 },
  );

  items.forEach((item) => observer.observe(item));

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const target = document.querySelector(
        `.rbsv4-timeline-modal__item[data-index="${dot.getAttribute("data-index")}"]`,
      );
      if (target) target.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    });
  });
}

document.addEventListener("DOMContentLoaded", initTimelineDots);
